<template>
  <div>
    <div class="flex justify-between border p-6">
      <div class="flex flex-col">
        <div class="mb-2 text-sm text-gray-700">
          {{ address.company && address.cif ? $page.constants.order.address_types.company.text : $page.constants.order.address_types.personal.text }}
        </div>
        <div class="text-lg mb-1 text-gray-900">
          {{ address.address }}, {{ address.postal_code }}
        </div>
        <span class="text-gray-800 text-base">
          {{ address.phone_number }}<span v-if="address.company && address.cif">, {{ address.company }}, {{ address.cif }}</span>
        </span>
      </div>
      <div class="flex flex-row items-center">
        <inertia-link class="mr-4" :href="route('shop.account.addresses.edit', { address: address.id })">
          <svg class="fill-current text-gray-700 hover:text-gray-900 w-6 h-6 transition ease-in-out duration-150" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path class="heroicon-ui" d="M6.3 12.3l10-10a1 1 0 0 1 1.4 0l4 4a1 1 0 0 1 0 1.4l-10 10a1 1 0 0 1-.7.3H7a1 1 0 0 1-1-1v-4a1 1 0 0 1 .3-.7zM8 16h2.59l9-9L17 4.41l-9 9V16zm10-2a1 1 0 0 1 2 0v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h6a1 1 0 0 1 0 2H4v14h14v-6z"/></svg>
        </inertia-link>
        <inertia-link method="delete" :href="route('shop.account.addresses.destroy', { address: address.id })">
          <svg class="fill-current text-gray-700 hover:text-gray-900 w-6 h-6 transition ease-in-out duration-150" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path class="heroicon-ui" d="M8 6V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2h5a1 1 0 0 1 0 2h-1v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8H3a1 1 0 1 1 0-2h5zM6 8v12h12V8H6zm8-2V4h-4v2h4zm-4 4a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1z"/></svg>
        </inertia-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    address: Object
  }
}
</script>
